import * as ACTION_TYPES from './action-types';
export const setUserPosition = (data) => {
  return {
    type : ACTION_TYPES.SET_USER_POSITION,
    payload: data 
  }
}

export const resetPosition = () => {
  return {
    type: ACTION_TYPES.RESET_POSITION
  }
}

export const setUserView = (data) => {
  return {
    type : ACTION_TYPES.SETVIEWS,
    payload: data 
  }
}

export const setUserFav = (data) => {
  return {
    type : ACTION_TYPES.USERFAV,
    payload: data 
  }
}
